import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useHistory, useParams } from 'react-router-dom';
import { Dialog } from '@material-ui/core';

import { Spinner } from 'core/components/spinner';
import { Label } from 'core/components/label';
import { useQueryParams } from 'core/hooks/useQueryParams';
import { useStore } from 'core/store';
import { getMergedOfferRedirectPath } from 'core/store/offer-store/offer-functions';
import useStyles from './rater-interstitial-modal.styles';

const RaterInterstitialModal = ({ open }) => {
  const classes = useStyles();
  const history = useHistory();
  const { offerId } = useParams();
  const { rater } = useQueryParams();

  const {
    offer: { getMergedOffer, toggleRaterInterstitialModal, setNavigatingInternally }
  } = useStore();

  useEffect(() => {
    async function fetchMergedOffer() {
      const mergedOffer = await getMergedOffer(offerId, rater);
      toggleRaterInterstitialModal(false);
      if (mergedOffer) {
        if (mergedOffer.id !== offerId) {
          // A real merge lands on a brand-new offer, so the newer-offer re-check on arrival
          // is redundant — skip it, exactly like the auto-redirect interstitial (#30994).
          // On a no-op the flag must NOT be set: the route param doesn't change, getOffer
          // never runs to consume it, and it would suppress the check on the next navigation.
          setNavigatingInternally(true);
        }
        // SPA navigation only (#35081): the offer provider re-runs getOffer off the
        // route-param change, so a full reload here paid the 3-12s offer load twice.
        // Carries the bridge link's query string when nothing merged; see
        // getMergedOfferRedirectPath for why a real merge must drop it (#34438)
        history.push(
          getMergedOfferRedirectPath({ offerId, mergedOfferId: mergedOffer.id, search: window.location.search })
        );
      }
    }
    fetchMergedOffer();
  }, [offerId, rater, getMergedOffer, toggleRaterInterstitialModal, setNavigatingInternally, history]);

  return (
    <Dialog open={open} classes={{ paper: classes.loading }}>
      <div className={classes.spinner}>
        <Spinner size={96} />
      </div>
      <Label className={classes.spinnerText}>Gathering offer details...</Label>
    </Dialog>
  );
};

RaterInterstitialModal.propTypes = {
  open: PropTypes.bool.isRequired
};

export default observer(RaterInterstitialModal);
